module.exports = __webpack_public_path__ + "static/media/car.76427f6b.svg";